import { Loader2 } from "lucide-react";
import { TableRow, TableCell } from "@/components/ui/table";

interface TableLoaderProps {
  colSpan: number;
  text?: string;
  className?: string;
}

export function TableLoader({
  colSpan,
  text = "Memuat data...",
  className = "h-40",
}: TableLoaderProps) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} className={`text-center ${className}`}>
        <div className="flex flex-col items-center justify-center space-y-3">
          <Loader2 className="w-8 h-8 animate-spin text-primary" />
          <span className="text-sm font-medium text-slate-500">{text}</span>
        </div>
      </TableCell>
    </TableRow>
  );
}
